import { translateSafely } from "@ankaadia/ankaadia-shared-frontend";
import { Component } from "@angular/core";
import { UserFeedbackCreateInput } from "@ankaadia/graphql";
import { Dialog } from "primeng/dialog";
import { finalize } from "rxjs";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { MessageService } from "../message/message.service";
import { NewUiUserFeedbackEditDialogComponent } from "./user-feedback-edit-dialog/new-ui-user-feedback-edit-dialog.component";
import { UserFeedbackService } from "./user-feedback.service";

@Component({
  selector: "new-ui-user-feedback",
  templateUrl: "./new-ui-user-feedback.component.html",
  imports: [TranslateDirective, NewUiUserFeedbackEditDialogComponent, Dialog],
})
export class NewUiUserFeedbackComponent {
  showSidebar: boolean;
  disabled: boolean;
  constructor(
    private readonly service: UserFeedbackService,
    private readonly messages: MessageService
  ) {}

  open(): void {
    this.showSidebar = true;
  }

  close(): void {
    this.showSidebar = false;
  }

  save(feedback: UserFeedbackCreateInput): void {
    this.disabled = true;
    this.service
      .create(feedback)
      .pipe(finalize(() => (this.disabled = false)))
      .subscribe(() => {
        this.messages.add({ severity: "success", summary: translateSafely("userFeedback.created") });
        this.close();
      });
  }
}
